import { object, string } from 'yup'
import { t } from 'ttag'

import { TEMPLATE_NAME_FIELD } from './common/CreateTemplate/model'

export const TEMPLATE_NAME_FIELD_LIMIT = 100

export const getCreateSchema = () =>
  object().shape({
    [TEMPLATE_NAME_FIELD]: string()
      .max(
        TEMPLATE_NAME_FIELD_LIMIT,
        t`Template name cannot exceed 100 characters.`,
      )
      .required(t`This field cannot be empty.`),
  })
